import { ITirPmDatepickerStyleVars } from "./ITirPmDatepickerStyleVars";

export class TirPmDatepickerStyleVars implements ITirPmDatepickerStyleVars {
  // Cells
  "--tir-pm-datepicker__cell-fs" = "1rem";
  "--tir-pm-datepicker__cell-fw" = "400";
  "--tir-pm-datepicker__cell-br" = "0.375rem";
  "--tir-pm-datepicker__cell-color" = "var(--text-primary, #272D37)";
  "--tir-pm-datepicker__cell-current-color" = "var(--text-info, #2A77EF)";
  "--tir-pm-datepicker__cell-hover-bg" = "var(--bg-secondary, #F8F6F9)";
  "--tir-pm-datepicker__cell-selected-color" =
    "var(--text-accent-inverted, #FFF)";
  "--tir-pm-datepicker__cell-selected-bg" = "var(--accent-accent, #34538D)";
  "--tir-pm-datepicker__cell-hover-selected-bg" =
    "var(--accent-hovered, #2D4C86)";

  // TirPmDatepicker
  "--tir-pm-datepicker__header-mb" = "0.5rem";
  "--tir-pm-datepicker__header-time-mr" = "0.5rem";
  "--tir-pm-datepicker__input-icon-size" = "var(--24, 1.5rem)";
  "--tir-pm-datepicker__input-button-padding" = "0 var(--4, 0.25rem)";

  // PickerContainer
  "--tir-pm-datepicker__container-br" = "0.5rem";
  "--tir-pm-datepicker__container-bg" = "var(--bg-base, #fff)";
  "--tir-pm-datepicker__container-border" =
    "0.063rem solid var(--neutral-10, #EAEAEB)";
  "--tir-pm-datepicker__container-shadow" =
    "1.188rem 3.375rem 1rem 0rem rgba(0, 0, 0, 0.00), 0.75rem 2.125rem 0.938rem 0rem rgba(0, 0, 0, 0.01), 0.438rem 1.188rem 0.75rem 0rem rgba(0, 0, 0, 0.05), 0.188rem 0.563rem 0.563rem 0rem rgba(0, 0, 0, 0.09), 0.063rem 0.125rem 0.313rem 0rem rgba(0, 0, 0, 0.10)";
  "--tir-pm-datepicker__container-padding" = "1rem";

  // DatesGrid
  "--tir-pm-datepicker__dates-grid-header-mt" = "0.5rem";
  "--tir-pm-datepicker__dates-grid-header-mb" = "0.5rem";
  "--tir-pm-datepicker__date-cell-size" = "2.5rem";
  "--tir-pm-datepicker__date-cell-no-current-color" =
    "var(--text-qunternery, #BFC0C3)";
  "--tir-pm-datepicker__date-cell-weekend-color" =
    "var(--text-negative, #EC2E14)";
  "--tir-pm-datepicker__date-cell-no-current-weekend-color" =
    "rgba(236, 46, 20, 0.50)";
  "--tir-pm-datepicker__date-cell-no-current-today-color" =
    "rgba(42, 118, 239, 0.5)";
  "--tir-pm-datepicker__week-cell-w" = "3.188rem";
  "--tir-pm-datepicker__week-num-h" = "1.5rem";
  "--tir-pm-datepicker__week-divider-color" = "var(--neutral-30, #BFC0C3)";

  // WeekDaysHeader
  "--tir-pm-datepicker__week-day-cell-size" = "2.5rem";
  "--tir-pm-datepicker__week-day-cell-padding" = "0 0 0.25rem 0";
  "--tir-pm-datepicker__week-day-cell-color" = "var(--text-secondary, #686C73)";
  "--tir-pm-datepicker__week-day-cell-fs" = "0.75rem";
  "--tir-pm-datepicker__week-day-cell-fw" = "400";
  "--tir-pm-datepicker__week-day-cell-lh" = "1rem";
  "--tir-pm-datepicker__week-day-cell-weekend-color" =
    "rgba(236, 46, 20, 0.80)";
  "--tir-pm-datepicker__week-num-cell-w" = "3.188rem";

  // NavigationControls
  "--tir-pm-datepicker__navigation-controls-gap" = "0.25rem";

  // MonthsGrid
  "--tir-pm-datepicker__months-grid-w" = "17.5rem";
  "--tir-pm-datepicker__months-grid-h" = "16.063rem";
  "--tir-pm-datepicker__month-cell-w" = "5.188rem";
  "--tir-pm-datepicker__month-cell-h" = "2.5rem";

  // YearsGrid
  "--tir-pm-datepicker__years-grid-w" = "17.5rem";
  "--tir-pm-datepicker__years-grid-h" = "16.063rem";
  "--tir-pm-datepicker__year-cell-w" = "5.188rem";
  "--tir-pm-datepicker__year-cell-h" = "2.5rem";

  // HoursGrid
  "--tir-pm-datepicker__hours-grid-w" = "17.5rem";
  "--tir-pm-datepicker__hour-cell-size" = "2.5rem";
  // MinutesGrid
  "--tir-pm-datepicker__minutes-grid-w" = "17.5rem";
  "--tir-pm-datepicker__minute-cell-h" = "2.5rem";
  // DatepickerInput
  "--tir-pm-datepicker__input-date-max-width" = "15.625rem";
  "--tir-pm-datepicker__input-date-min-width" = "15.625rem";
  "--tir-pm-datepicker__input-datetime-max-width" = "15.625rem";
  "--tir-pm-datepicker__input-datetime-min-width" = "15.625rem";
  "--tir-pm-datepicker__input-week-max-width" = "10rem";
  "--tir-pm-datepicker__input-week-min-width" = "10rem";
  "--tir-pm-datepicker__input-year-max-width" = "4.5rem";
  "--tir-pm-datepicker__input-year-min-width" = "4.5rem";
  "--tir-pm-datepicker__input-month-max-width" = "10rem";
  "--tir-pm-datepicker__input-month-min-width" = "10rem";
  "--tir-pm-datepicker__input-time-max-width" = "10rem";
  "--tir-pm-datepicker__input-time-min-width" = "10rem";

  static setVars(vars: TirPmDatepickerStyleVars) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${vars[key as keyof TirPmDatepickerStyleVars]};\n`;
    });
    styleElement.textContent = `
  :root {
    ${varsStr}
  }
`;

    document.head.appendChild(styleElement);
  }
}
